module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.671c019.eot";